import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";
import { useCallback, useEffect } from "react";

import { Logger } from "@moment/logging";

import { $gitConfig, $gitConfigDraft } from "../../internal/git";
import { paths } from "../../internal/paths/paths.atom";

const logger = new Logger("useGitConfig");

/**
 * Hook to access git branches
 * @param documentId - The document ID
 * @returns List of branches
 */
export const useGitConfig = () => {
	const config = useAtomValue(loadable($gitConfig));
	const setConfig = useSetAtom($gitConfig);

	useEffect(() => {
		if (config.state === "hasError") {
			logger.error("Failed to load git config", { error: config.error });
		}
	}, [config.state]);

	const updateKey = useCallback(
		(key: string, value: string | number | null) => {
			setConfig({ key, value });
		},
		[setConfig]
	);

	const refetch = useCallback(() => {
		setConfig(undefined);
	}, [setConfig]);

	return {
		config: config.state === "hasData" ? config.data : undefined,
		updateKey,
		refetch,
		isLoading: config.state === "loading",
		isError: config.state === "hasError",
		error: config.state === "hasError" ? config.error : undefined,
	};
};
